import type { ObjectId } from "@bbj-types/utils";
import { getAxiosErrorMessage } from "@root/api/tools/axios";
import { axiosCandidateInstance } from "./axios";

export interface IVerifyPhoneNumberResponse {
  available: boolean;
}

export const verifyPhoneNumbersAvailability = async (candidateId: ObjectId, number: string) => {
  try {
    const { data } = await axiosCandidateInstance.get<IVerifyPhoneNumberResponse>(`${candidateId}/verify/phoneNumber`, {
      params: { phone: number },
    });
    return data.available;
  } catch (error) {
    window.publish("feedback", {
      severity: "error",
      message: getAxiosErrorMessage(error),
    });
  }
};
